var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"to":{ name: 'contract', params: { contractId: _vm.contract.id } }}},[_c('v-list-item-content',[(_vm.building)?_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.building.name)+" - N°"+_vm._s(_vm.contract.number)+" ")]):_vm._e(),_c('v-list-item-subtitle',[_vm._v(" "+_vm._s(_vm.countSheet)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }